import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';

import { LoginCard } from './components';
import classes from './Auth0Login.module.css';

export const Auth0Login: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = (): void => {
    loginWithRedirect();
  };

  return (
    <div className={classes.loginPageContainer}>
      <LoginCard>
        <LoginCard.Logo />
        <LoginCard.Title>Welcome Back!</LoginCard.Title>
        <LoginCard.Description className='mb-4'>
          Please log in to continue.
        </LoginCard.Description>
        <LoginCard.PrimaryButton onClick={handleLogin}>
          Log In
        </LoginCard.PrimaryButton>
      </LoginCard>
    </div>
  );
};